import React, { useState } from 'react';
import './Button.css';



const  Button=(props)=>{

// const [hoverBtn, setHoverBtn] = useState()




const [isHovering, setIsHovering] = useState(false);


    return (
    <>



    <div className='btnWelcomeBg'>
        <button onClick={props.onClick}  className={isHovering ? "gameBtn customBtnHover" : "gameBtn customBtn" } onMouseOver={()=> setIsHovering(true)} onMouseOut={()=>  setIsHovering(false)}>          
           <img className='btnImg' src={props.src} alt={props.alt}/> <span className='btnText'>{props.btnName}</span>         
        </button>
    </div>
    </>
    )
}


export default Button;